import logo from "assets/img/logo/logo_aig_login-2.png";
import React from "react";
import LoadingScreen from "react-loading-screen";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { FetchListadoEndosos } from "../../redux/actions/aEndososBeneficiarios";
import TablaVehiculos from "./Vehiculos/TablaVehiculos";
import { ramos_endosos_beneficiarios } from "../../utils/constants";
import SeleccionEndosos from "./SeleccionEndosos";


class ListaEndosos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paso: "listado"
    }
  }

  async componentDidMount() {
    const queryParams = new URLSearchParams(this.props.location.search);
    const poliza = queryParams.get("poliza");
    const sucursal = queryParams.get("sucursal");
    const ramo = queryParams.get("ramo");
    const body = {
      poliza,
      sucursal,
      ramo
    };
    this.setState(body);
  }

  ingresarEndoso = (endoso) => {
    this.setState({
      paso: "seleccionEndoso",
      endosoSeleccionado: endoso
    });
  }

  cancelarEndoso = () => {
    this.setState({
      paso: "listado",
    });
  }

  renderTabla = () => {
    if (ramos_endosos_beneficiarios[this.state.ramo] !== undefined) {
      return (
        <>
          {ramos_endosos_beneficiarios[this.state.ramo] === "vehiculos" && (
            <TablaVehiculos
              {...this.state}
              funciones={
                {
                  ingresarEndoso: this.ingresarEndoso
                }
              }
            />
          )}
        </>
      );
    }
  }

  render() {
    const {
      datosEndosos
    } = this.props;
    return (
      <LoadingScreen
        loading={datosEndosos.isLoadingEndosos}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text={"Obteniendo registros..."}
      >
        {this.state.paso === "listado" && this.renderTabla()}
        {this.state.paso === "seleccionEndoso" &&
          <SeleccionEndosos
            {...this.state}
            funciones={
              {
                cancelarEndoso: this.cancelarEndoso
              }
            }
          />
        }
      </LoadingScreen>
    );
  }
}

const mapStateToProps = (state) => ({
  datosEndosos: state.dataEndosos ? state.dataEndosos : false
});

const mapDispatchToProps = (dispatch) => {
  return {

  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ListaEndosos)
);